import { Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CountriesService }             from './countries.service';
import { CountryTypesModel }            from '../sessions/models/session.country-types';
import { ImportColumnModel }            from '../imports/typings/imports.column';
import { ImportOptionsModel }           from '../imports/typings/imports.option';
import { ImportTransformFunctionModel } from '../imports/typings/imports.transform-function';
import { MessagesService }              from '../messages/messages.service';
import { RemoveComponent }              from '../table/cell-components/actions/remove.component';
import { StateTypeModel }               from './typings/countries.state-type';
import { Table }                        from '../table/types/table';

@Component({
  selector   : 'wor-countries',
  template: require('./countries.component.html')
})
export class CountriesComponent implements OnInit {
  @BlockUI('countryBlock') block : NgBlockUI;

  @Input() countries         : Array<CountryTypesModel>;
  @Input() ourColumns        : Array<ImportColumnModel>;
  @Input() transformFunctions: Array<ImportTransformFunctionModel>;

  states : Array<StateTypeModel> = [];

  collapsed = false;
  country   = {} as CountryTypesModel;

  importOptions: ImportOptionsModel = {
    collapsed         : true,
    name              : 'state_column',
    ourColumns        : [],
    placeholder       : this.translateService.instant('IMPORT_SPACE.SELECT_FIELD_IN_STATES'),
    title             : this.translateService.instant('IMPORT_SPACE.IMPORT_STATES'),
    transformFunctions: [],
    url               : '/imports/perform_state_type_import'
  };

  tableSettings : Table = {
    columns: [
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: event => this.removeState(event)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false,
      },
      {
        classes: 'text-left',
        field  : 'code',
        header : {
          text: this.translateService.instant('COMPANY_SPACE.SETTINGS.CODE')
        }
      },
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.NO_STATES_FOR_COUNTRY')
    },
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    private countriesService: CountriesService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  addNewStateType () : void {
    this.countriesService.addNeStateType(this.country)
    .then(() => this.getStates(this.country.code))
    .catch(error => this.messagesService.error(error));
  }

  addNewType () : void {
    this.countriesService.addNewType()
    .then(( country : CountryTypesModel ) => {
      this.country = country;

      return this.countriesService.get();
    })
    .then(( countries : Array<CountryTypesModel> ) => {
      this.countries = countries;
    })
    .catch(error => this.messagesService.error(error));
  }

  getStates ( code : string ) : void {
    this.block.start();

    this.country = Object.assign({}, this.countries.find(country => country.code === code));

    this.tableSettings.empty.text = this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.NO_STATES_FOR_COUNTRY', {
      name: this.translateService.instant(this.country.language_label)
    });

    this.countriesService.getStates(this.country)
    .then(( states : Array<StateTypeModel> ) => {
      this.states = states;
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  ngOnInit () : void {
    this.importOptions.ourColumns         = this.ourColumns;
    this.importOptions.transformFunctions = this.transformFunctions;
  }

  removeState ( state : StateTypeModel ) : void {
    this.block.start();

    this.countriesService.removeState(state)
    .then(() => {
      this.getStates(this.country.code);

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.STATE'), 'success');
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  submit ( form : NgForm ) : void {
    this.block.start();

    this.countriesService.update(this.country)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.UPDATED.COUNTRY'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  toggleBox () : void {
    this.collapsed = !this.collapsed;
  }
}
